// Rastreamento do site (Pixel "Entre Elas Pixel" + contador próprio no D1 do site de links).
// Só roda nas páginas públicas: admin, check-in, perfil e links com token ficam de fora, porque o Pixel
// envia o endereço inteiro para a Meta. Nenhum dado pessoal é enviado. Nunca derruba a página.
const PIXEL = "1380132023987817";
const CONTADOR = "https://link.allbridgesolutions.pro/_evento";
const PUBLICAS = /^\/($|cadastro\/?$|comunidade\/?$|evento\/[^/]+\/?$|proximo-evento\/[^/]+(\/pagamento)?\/?$)/;
const ORIGEM = "entre-elas-origem";

type Fbq = ((...a: unknown[]) => void) & { disablePushState?: boolean };
const w = window as unknown as { fbq?: Fbq };
let publica = false;
let rolou = false;

function carregarPixel() {
  if (w.fbq) return;
  const f = function (...a: unknown[]) {
    const s = f as unknown as { callMethod?: (...x: unknown[]) => void; queue: unknown[] };
    if (s.callMethod) s.callMethod(...a);
    else s.queue.push(a);
  } as unknown as Fbq & { push: unknown; loaded: boolean; version: string; queue: unknown[] };
  f.push = f;
  f.loaded = true;
  f.version = "2.0";
  f.queue = [];
  f.disablePushState = true; // quem conta a troca de página é a função paginaVista
  w.fbq = f;
  (w as unknown as { _fbq: unknown })._fbq = f;
  const t = document.createElement("script");
  t.async = true;
  t.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(t);
  f("set", "autoConfig", false, PIXEL); // sem leitura automática de formulário
  f("init", PIXEL);
}

function origem() {
  try {
    const q = new URLSearchParams(location.search);
    const de = q.get("de") || q.get("utm_campaign") || q.get("utm_source");
    if (de) sessionStorage.setItem(ORIGEM, de.slice(0, 80));
    return sessionStorage.getItem(ORIGEM) || "";
  } catch {
    return "";
  }
}

function contar(t: string, x: string) {
  try {
    navigator.sendBeacon(CONTADOR, new URLSearchParams({ t, x, p: "entre-elas-site", de: origem() }));
  } catch {
    /* contador nunca atrapalha o site */
  }
}

// Evento padrão ou próprio do Pixel + contador.
export function marcar(evento: string, proprio = false, x = "") {
  try {
    if (publica && w.fbq) w.fbq(proprio ? "trackCustom" : "track", evento, x ? { destino: x } : {});
  } catch {
    /* idem */
  }
  if (publica) contar("evento", (evento + (x ? "-" + x : "")).toLowerCase());
}

export function paginaVista(caminho: string) {
  publica = PUBLICAS.test(caminho);
  if (!publica) return;
  rolou = false;
  try {
    carregarPixel();
    w.fbq?.("track", "PageView");
    if (/^\/(proximo-)?evento\//.test(caminho)) w.fbq?.("track", "ViewContent");
  } catch {
    /* idem */
  }
  contar("visita", caminho === "/" ? "inicio" : caminho.replace(/^\/+|\/+$/g, ""));
}

export function ligarEscutas() {
  document.addEventListener(
    "click",
    (e) => {
      const a = (e.target as Element | null)?.closest?.("a[href]") as HTMLAnchorElement | null;
      if (!a) return;
      try {
        const h = new URL(a.href, location.href);
        if (/wa\.me|whatsapp\.com/.test(h.hostname)) marcar("Contact");
        else if (h.host !== location.host) marcar("CliqueLink", true, h.hostname.replace(/^www\./, ""));
      } catch {
        /* idem */
      }
    },
    true,
  );
  window.addEventListener(
    "scroll",
    () => {
      const d = document.documentElement;
      if (!rolou && d.scrollHeight > innerHeight * 1.5 && (scrollY + innerHeight) / d.scrollHeight >= 0.5) {
        rolou = true;
        marcar("RolouMetade", true);
      }
    },
    { passive: true },
  );
}
